module.exports = __webpack_public_path__ + "static/media/img-4.b6db5218.png";